export class ChartHelper {
    private static colorpattern1 = [
        "#EF476F", "#FFD166", "#06D6A0", "#118AB2", "#073B4C",
        "#247BA0", "#70C1B3", "#B2DBBF", "#F3FFBD", "#FF1654",
        "#2B2D42", "#8D99AE", "#EDF2F4", "#EF233C", "#D90429",
        "#ED6A5A", "#F4F1BB", "#9BC1BC", "#5CA4A9", "#5CA4A9",
    ];
    private static colorpattern2 = [
        "#F694C1", "#E4C1F9", "#EDE7B1", "#A9DEF9",
        "#114B5F", "#9C89B8", "#1A936F", "#F0A6CA",
        "#F3E9D2", "#EFC3E6", "#C6DABF", "#F0E6EF",
    ];
    private static colorpattern3 = [
        "#5BC0EB", "#FDE74C", "#9BC53D", "#FA7921",
        "#A9BCD0", "#58A4B0", "#373F51", "#1B1B1E",
        "#22223B", "#9A8C98", "#C9ADA7", "#E63946",
    ];
    private static colorpattern4 = [
        "#BCE784", "#5DD39E", "#348AA7", "#513B56",
        "#2A9D8F", "#E9C46A", "#F4A261", "#E76F51",
        "#DAEED3", "#D4EAF6", "#A2E3C4", "#FCF7DF",
    ];

    static getColorScheme(schemeNumber: number) {
        switch (schemeNumber) {
            case 1:
                return ChartHelper.colorpattern1;
            case 2:
                return ChartHelper.colorpattern2;
            case 3:
                return ChartHelper.colorpattern3;
            case 4:
                return ChartHelper.colorpattern4;
            default:
                return ChartHelper.colorpattern1;
        }
    }
}

export interface ChartBaseProps {
    colorscheme?: 1 | 2 | 3 | 4;
    legendPosition?: "top" | "right" | "bottom" | "left";
    hideLegend?: boolean,
    disableResponsive?: boolean,
    maintainAspectRatio?: boolean;
    hideXAxes?: boolean,
    hideYAxes?: boolean,
    title?: string;
}

export interface ChartDataConfig {
    labels: string[];
    datasets: { description: string, values: number[], backgroundColor?: string, borderColor?: string }[];
}
